<div *ngIf="isOffline" fxAlign="row" fxLayoutAlign="center center">
  <mat-icon color="warn">warning</mat-icon>
  <span>
    {{ "common.offline-indicator.offline-hint" | translate }}
  </span>
</div>
